export default __webpack_public_path__ + "static/media/Pos1.63acc80a.svg";